import { Controller } from "stimulus"

// Shared open/close behavior:
// toggle, outside-click, Escape, and the hidden/aria-expanded bookkeeping.
export default class extends Controller {
  toggle(event) {
    event.stopPropagation()
    this.setOpen(this.popoverTarget.hasAttribute("hidden"))
  }

  close() {
    this.setOpen(false)
  }

  closeOnOutsideClick(event) {
    if (this.popoverTarget.hasAttribute("hidden")) return
    if (!event.target.isConnected) return
    if (this.popoverTarget.contains(event.target)) return

    const expander = this.ariaExpander
    if (expander && expander.contains(event.target)) return

    this.setOpen(false)
  }

  closeOnEscape(event) {
    if (event.key !== "Escape") return
    if (this.popoverTarget.hasAttribute("hidden")) return

    this.setOpen(false)
  }

  setOpen(open) {
    if (open) {
      this.popoverTarget.removeAttribute("hidden")
    } else {
      this.popoverTarget.setAttribute("hidden", "hidden")
    }

    const expander = this.ariaExpander
    if (expander) expander.setAttribute("aria-expanded", String(open))
  }

  get ariaExpander() {
    return null
  }
}
